module.exports = __webpack_public_path__ + "media/images/illustrations/boarding-school-f3f0a3e1400e99967043e8452298ffe9.svg";